export const DATE_FORMAT = {
  isoDate: 'YYYY-MM-DD',
  monthShortName: 'MMM',
  dayShortName: 'ddd',
  timeAmPm: 'hh:mm A',
} as const;
